//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignPromptDialog from '@/components/SignPromptDialog';

export default {
    props: {
        type: String,
        amendmentIndex: Number,
        editItem: Object,
        update: Function,
        reload: Function,
        isDirty: Boolean,
        noDirtyMessage: Boolean,
        signedByFilter: Array,
        emailSent: Boolean,
        gutter: {
            type: String,
            default: 'md',
        },
    },

    data() {
        return {
            signedBy: null,
            isSigningOverlayOpen: false,
            previewOnly: false,
        };
    },

    methods: {
        signOffline() {
            this.$q.dialog({
                component: SignPromptDialog,
                parent: this,
                title: `Podpis ${$.ttl(this.type, 2)}`,
                message: 'Vyberte datum, čas a autora podpisu:',
                signedByFilter: this.signedByFilter,
            }).onOk(async ({ date, signedBy }) => {
                this.$emit('sign-offline', {
                    editItem: this.editItem,
                    update: this.update,
                    date,
                    signedBy,
                });
            });
        },
        signRemotely() {
            this.$q.dialog({
                component: SignPromptDialog,
                parent: this,
                title: `Podpis ${$.ttl(this.type, 2)}`,
                message: `Vyberte podepisujícího a zadejte e-mail, na který zašleme ${$.tts(this.type, 4)} k podpisu:`,
                signedByFilter: this.signedByFilter,
                noDate: true,
                withEmail: true,
            }).onOk(async ({ signedBy, email }) => {
                await axios.post('/doc/email', {
                    caseId: this.editItem.id,
                    type: this.type,
                    amendmentIndex: this.amendmentIndex,
                    signedByRef: signedBy.id,
                    email,
                });

                notifyOk("Odeslání proběhlo úspěšně.");

                this.reload();
            });
        },
        signOnline() {
            this.$q.dialog({
                component: SignPromptDialog,
                parent: this,
                title: `Podpis ${$.ttl(this.type, 2)}`,
                message: `Vyberte podepisujícího:`,
                signedByFilter: this.signedByFilter,
                noDate: true,
            }).onOk(async ({ signedBy }) => {
                this.signedBy = signedBy;
                this.previewOnly = false;
                this.isSigningOverlayOpen = true;
            });
        },
        showPreview() {
            this.previewOnly = true;
            this.isSigningOverlayOpen = true;
        },
        async cancelRemote() {
            await axios.post('/doc/cancel', {
                caseId: this.editItem.id,
                type: this.type,
                amendmentIndex: this.amendmentIndex,
            });

            notifyOk("Zneplatnění e-mailu proběhlo úspěšně.");

            this.reload();
        },
    },
};
